
<mat-card class="details">
  <table style="width: 100%; height: 100%">
    <tr>

      <td style="width: 85%;">


        <mat-card class="contDetails">


          <table style="width: 100%">
            <tr>
              <td style="width: 10%">
                <div class="maher" (click)="myApp.showCharts()"></div>
              </td>
              <td *ngIf="myUser.role=='HAULIER' || myUser.canSeeAllData=='1'" style="text-align: right; width: 35%">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Line Operator</mat-label>
                  <mat-select  [(value)]="sslLine" (selectionChange)="getUtcsRecord()">
                    <mat-option class="myOption2" *ngFor="let lr of ssls" [value]="lr.code">{{lr.description}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td *ngIf="myUser.canSeeAllData=='1'" style="width: 45%">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Trucking Company</mat-label>
                  <mat-select  [(value)]="truckingCo" (selectionChange)="getUtcsRecord()" >
                    <mat-option class="myOption2"  *ngFor="let lr of truckers" [value]="lr.id">{{lr.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td style="width: 5%">
              </td>

            </tr>
            <tr>
              <td colspan="4" style="width: 100%; text-align: center">
                <div class="errorDiv2" style="font-size: 17px"  *ngIf="noDataFound && submitted">Not On File</div>


              </td>
            </tr>

          </table>




          <div class="titleFont" style="padding-left: 1%; font-size: 23px; padding-top: 20px; padding-bottom: 10px; ">Universal Trucker Clearance System</div>


          <table style="width: 100%; height: 100%; padding: 0px; margin: 0px">
            <tr>
              <td style="width: 80%; height: 100%; text-align: center;" >
                <table  class="table-fill" style="height: 100%">
                  <tr>

                    <td style="vertical-align: top; height: 100%">
                      <div>
                        <mat-form-field appearance="outline"  >
                          <mat-label style="font-size: 18px; color: #E61E00">Steamship Line</mat-label>
                          <input  [(ngModel)]="utcsDetail.shippinglinename" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <div>
                        <mat-form-field appearance="outline"  >
                          <mat-label style="font-size: 18px; color: #E61E00">Trucking Company</mat-label>
                          <input [(ngModel)]="utcsDetail.truckername" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <div>
                        <mat-form-field appearance="outline"  >
                          <mat-label style="font-size: 18px; color: #E61E00">Trucker Status</mat-label>
                          <input [(ngModel)]="utcsDetail.trucklinestatus" matInput readonly/>
                        </mat-form-field>
                      </div>
                      <div>
                        <mat-form-field appearance="outline"  >
                          <mat-label style="font-size: 18px; color: #E61E00">Account Status</mat-label>
                          <input [(ngModel)]="utcsDetail.lifecyclestatedescription" matInput readonly/>
                        </mat-form-field>
                      </div>
                    </td>


                    <td style="vertical-align: top; height: 100% ">
                      <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%">

                        <div >
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5% ;padding-bottom: 15px  ">Expiration Dates</div>

                          <div style="padding-top: 2px">
                            <mat-form-field appearance="outline">
                              <mat-label style="font-size: 18px; color: #E61E00">Insurance Expiration</mat-label>
                              <input [(ngModel)]="utcsDetail.insuranceexpirationdate_fmt"  matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div>
                            <mat-form-field appearance="outline" >
                              <mat-label style="font-size: 18px; color: #E61E00">Credit Expiration</mat-label>
                              <input [(ngModel)]="utcsDetail.creditexpirationdate_fmt" matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div>
                            <mat-form-field appearance="outline" >
                              <mat-label style="font-size: 18px; color: #E61E00">Expiration Date</mat-label>
                              <input [(ngModel)]="utcsDetail.expirationdate_fmt" matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div style="padding-bottom: 17%"></div>
                      </div>
                      </div>
                    </td>

                    <td style="vertical-align: top;">
                      <div style="background-color:  rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">

                        <div >
                          <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Audit</div>

                          <div style="padding-top: 2px">
                            <mat-form-field appearance="outline">
                              <mat-label style="font-size: 18px; color: #E61E00">Created Date</mat-label>
                              <input [(ngModel)]="utcsDetail.createddate_fmt"  matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div>
                            <mat-form-field appearance="outline" >
                              <mat-label style="font-size: 18px; color: #E61E00">Created By</mat-label>
                              <input [(ngModel)]="utcsDetail.createdby" matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div>
                            <mat-form-field appearance="outline" >
                              <mat-label style="font-size: 18px; color: #E61E00">Modified Date</mat-label>
                              <input [(ngModel)]="utcsDetail.modifieddate_fmt" matInput readonly/>
                            </mat-form-field>
                          </div>
                          <div>
                            <mat-form-field appearance="outline" >
                              <mat-label style="font-size: 18px; color: #E61E00">Modified By</mat-label>
                              <input [(ngModel)]="utcsDetail.modifiedby" matInput readonly/>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </mat-card>
      </td>
      <td class="loginPic" style="width: 20%;  height: 100%;  vertical-align: top;">

      </td>
    </tr>
  </table>

</mat-card>
